import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { useIntl } from 'react-intl';
import globalMessages from '../../../messages';
import billingMessages from '../../../pages/billing/messages';
import app from "firebase";
import { setNotificationsToBeInactive } from 'src/api/notificationApi';
import { useUserProvider } from 'src/providers/UserProvider';
import { updateUserOnlineStatus } from 'src/hooks/useOnlineStatusTracker';
import firebase from 'firebase';
import { auth } from 'src/firebase';
import globalState, { GlobalState } from 'src/globalState';
import useNavigation from 'src/hooks/useNavigation';

type Props = {
  open: boolean;
  onManageSubscriptions: () => void;
  setAppLoading?: (value: boolean) => void;
};

const AppBillingBlockDialog = ({ open, onManageSubscriptions, setAppLoading }: Props) => {
  const { formatMessage } = useIntl();
  const {user, resetUser} = useUserProvider();
  const { navigation } = useNavigation();

    const handleLogout = async () => {
      // check if messaging is supported at first by the browser
      try{
        setAppLoading && setAppLoading(true);
        if(app.messaging.isSupported()){
          const messaging = app.messaging();
          messaging.deleteToken().then();
          let token = await messaging.getToken().then(token => token).catch(e => false);
          
          if (typeof token === "string") {
            setNotificationsToBeInactive(user?.id || "", token);
          }
        }
        resetUser();
      } catch (error) {
        console.log('handleLogout', error);
      }
      const language = user?.language;
  
      await updateUserOnlineStatus(user?.id || "", {
        isOnline: false,
        onlineStateLastChanged: firebase.firestore.FieldValue.serverTimestamp(),
      });
  
      setTimeout(() => {
        auth
          .signOut()
          .then((_) => {
            resetUser();
            setAppLoading && setAppLoading(false);
            navigation(`/${language}`);
          })
          .catch((err) => {
            globalState.update((state: GlobalState) => {
              state.toastQueue.push({
                message:  formatMessage(globalMessages.error_signout),
                severity: "error",
              });
          });
          });
      }, 1000);
    };

  return (
    <Dialog open={open} disableEscapeKeyDown maxWidth="sm" fullWidth>
      <DialogTitle>{formatMessage(billingMessages.billing_not_set)}</DialogTitle>
      <DialogContent>
        <Typography>
          {formatMessage(billingMessages.no_subscription_plan)}
        </Typography>
      </DialogContent>
      <DialogActions style={{padding: 20}}>
        <Button color="primary" variant="outlined" onClick={handleLogout}>
          {formatMessage(globalMessages.signout_button)}
        </Button>
        <Button color="primary" variant="contained" onClick={onManageSubscriptions}>
          {formatMessage(globalMessages.manage_subscriptions)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AppBillingBlockDialog;
